import React, { Component } from "react";
import { connect } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { routes } from "./routes";
import { setLoggedOut } from "./modules/auth/auth.actions";

const RouteElement = connect((state) => ({
    authenticatedUser: state.auth.authenticatedUser,
}))(({ authenticatedUser, RouteType, PermissionName, Component }) => {
    const Wrapper = RouteType || React.Fragment;
    return (
        <Wrapper authenticatedUser={authenticatedUser} permissionName={PermissionName}>
            <Component />
        </Wrapper>
    );
});

const router = createBrowserRouter(
    routes.map(({ RouteType, path, Component, PermissionName }) => ({
        path: path,
        element: (
            <RouteElement
                RouteType={RouteType}
                PermissionName={PermissionName}
                Component={Component}
            />
        ),
    }))
);

class AppComponent extends Component {
    async componentDidMount() {
        if (
            this.props.authenticatedUser === undefined ||
            this.props.authenticatedUser === null ||
            Object.keys(this.props.authenticatedUser).length === 0
        ) {
            this.props.setLoggedOut();
        }
    }

    render() {
        return <RouterProvider router={router} />;
    }
}

const mapStateToProps = (state) => {
    return {
        authenticatedUser: state.auth.authenticatedUser,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setLoggedOut: () => dispatch(setLoggedOut()),
    };
};

export const App = connect(mapStateToProps, mapDispatchToProps)(AppComponent);